import React, { useEffect } from 'react';
import classes from './login.module.css';
import { Form, message, Alert } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { EyeOutlined } from '@ant-design/icons';
import {
    GoogleReCaptchaProvider,
    GoogleReCaptcha
} from 'react-google-recaptcha-v3';
import { useLogin } from './useLogin';
import TextInput from '../../components/formDesign/TextInput/textInput';
import LandingWelcome from '../../components/LandingWelcome/landingWelcome';

import ButtonNode from '../../components/formDesign/ButtonNode/buttonNode';
import CheckboxNode from '../../components/formDesign/CheckboxNode/checkboxNode';

import {
    IconUserGreySvg,
    IconPasswordLockGreySvg,
    IconPasswordHideGreySvg,
    IconPasswordVisibleGreySvg
} from '../../components/IconsSvg/iconsSvg';

const Login = props => {

    const { formatMessage } = useIntl();
    const [messageApi, contextHolder] = message.useMessage();

    const talons = useLogin();

    const {
        form,
        clientReady,
        loginLoading,
        onStartLogin,
        errorMsg,
        showErrorMsg,
        setShowErrorMsg,
        handleForgetPassWord,
        handleCloseMessage,
        handleReCaptchaVerify,
        refreshReCaptcha,
        reCaptchaKey,
        recaptchaToken,
        reCaptchaEnable
    } = talons;

    // useEffect(() => {
    //     if (showErrorMsg) {
    //         messageApi.open({
    //             type: 'error',
    //             content: errorMsg,
    //         });
    //         setShowErrorMsg(false);
    //     }

    // }, [showErrorMsg, errorMsg, messageApi, setShowErrorMsg]);

    return (
        <div className={classes.root}>
            {contextHolder}
            <aside className={classes.panel}>
                <div className={classes.panel_left}>
                    <LandingWelcome />
                </div>
                <div className={classes.panel_right}>
                    <div className={classes.right_box}>
                        <div className={classes.right_content}>
                            <h1>
                                <FormattedMessage id="login.panelName" defaultMessage={"Sign-in system"} />
                            </h1>
                            <Form className={classes.form} form={form} name="login_form" onFinish={onStartLogin} layout='vertical'>
                                <TextInput
                                    name="email"
                                    rules={[{
                                        required: true,
                                        message: formatMessage({
                                            id: "form.isRequired",
                                            defaultMessage: "{name} is required!"
                                        }, {
                                            name: formatMessage({
                                                id: "form.email",
                                                defaultMessage: "Email"
                                            })
                                        })
                                    }]}
                                    placeholder={formatMessage({
                                        id: "form.placeholder",
                                        defaultMessage: "Please enter {name} "
                                    }, {
                                        name: formatMessage({
                                            id: "form.emailPlaceholder",
                                            defaultMessage: "Email"
                                        })
                                    })}
                                    styles={{
                                        flexDirection: 'column'
                                    }}
                                    prefix={<IconUserGreySvg />}
                                />
                                <TextInput
                                    name="password"
                                    rules={[{
                                        required: true,
                                        message: formatMessage({
                                            id: "form.isRequired",
                                            defaultMessage: "{name} is required!"
                                        }, {
                                            name: formatMessage({
                                                id: "form.password",
                                                defaultMessage: "Password"
                                            })
                                        })
                                    }]}
                                    inputType="password"
                                    prefix={<IconPasswordLockGreySvg />}
                                    placeholder={formatMessage({
                                        id: "form.placeholder",
                                        defaultMessage: "Please enter {name} "
                                    }, {
                                        name: formatMessage({
                                            id: "form.passwordPlaceholder",
                                            defaultMessage: "Password"
                                        })
                                    })}
                                    iconRender={(visible) => (visible ? IconPasswordVisibleGreySvg
                                        : IconPasswordHideGreySvg)}
                                />
                                <div className={classes.form_other}>
                                    <CheckboxNode
                                        name="remember"
                                        valuePropName="checked"
                                    >
                                        <FormattedMessage id="login.rememberMeLabel" defaultMessage={"Remember me"} />
                                    </CheckboxNode>
                                    <ButtonNode
                                        type="link"
                                        onClick={handleForgetPassWord}
                                    >
                                        <FormattedMessage id="login.forgetBtn" defaultMessage={"Forget the password ?"} />
                                    </ButtonNode>
                                </div>
                                {showErrorMsg ? <div className={classes.form_other}>
                                    <Alert
                                        message=""
                                        description={errorMsg}
                                        type="error"
                                        closable={true}
                                        onClose={handleCloseMessage}
                                        style={{ width: '100%' }}
                                    />
                                </div> : ''}

                                {reCaptchaEnable ? <div style={{ marginBottom: '16px' }}>
                                    <GoogleReCaptchaProvider
                                        reCaptchaKey={reCaptchaKey}
                                        language="en"
                                        scriptProps={{
                                            async: false, // optional, default to false,
                                            defer: false, // optional, default to false
                                            appendTo: 'head', // optional, default to "head", can be "head" or "body",
                                            nonce: undefined // optional, default undefined
                                        }}
                                        container={{ // optional to render inside custom element
                                            element: "GoogleReCaptchaProvider",
                                            parameters: {
                                                badge: 'inline', // optional, default undefined
                                                theme: 'dark', // optional, default undefined
                                            }
                                        }}
                                    >
                                        <div id='GoogleReCaptchaProvider'></div>
                                        <GoogleReCaptcha
                                            onVerify={handleReCaptchaVerify}
                                            refreshReCaptcha={refreshReCaptcha}
                                            action="login"
                                        />
                                    </GoogleReCaptchaProvider>
                                </div> : null}
                                <Form.Item shouldUpdate>
                                    {() => (
                                        <ButtonNode
                                            type="primary"
                                            htmlType="submit"
                                            disabled={
                                                !recaptchaToken && reCaptchaEnable || !clientReady ||
                                                !!form.getFieldsError().filter(({ errors }) => errors.length).length
                                            }
                                            loading={loginLoading}
                                            style={{ width: '100%' }}
                                        >
                                            <FormattedMessage id="login.loginBtn" defaultMessage={"Sign In"} />
                                        </ButtonNode>
                                    )}
                                </Form.Item>
                            </Form>
                        </div>
                        {/* <div className={classes.right_bottom}>
                            <FormattedMessage id="global.copyright " defaultMessage={"Copyright @ 2024 BCNetcom. All Rights Reserved"} />
                        </div> */}
                    </div>
                </div>
            </aside>
        </div>
    )
}

export default Login;